import styled from "styled-components";
import { Currency } from "../../../types/Currency/Currency";
import { PricingRule } from "../../../types/PricingRule/PricingRule";
import Price from "../../../@ui/Price";
import { usePurchaseLicenceContext } from "../../../context/PurchaseLicence/PurchaseLicenceContext";
import { Spinner } from "react-bootstrap";
import PaymentTypeLabel from "./PaymentTypeLabel";
import { LicenceTypePurchase } from "../../../types/Licences/LicenceTypePurchase";
import { useCurrencyContext } from "../../../context/Currency/CurrencyContext";

interface SingleUserPricingProps {
  licence: LicenceTypePurchase;
}

const PricingHeader = styled.h4`
  font-size: 1.75rem;
`;

const SingleUserPricing = ({ licence }: SingleUserPricingProps) => {
  const { loading } = usePurchaseLicenceContext();
  const { selectedCurrency } = useCurrencyContext();

  const price =
    licence.pricingRules && licence.pricingRules.length > 0
      ? licence.pricingRules[0].transactionCostIncTax
      : 0;

  return (
    <>
      <PricingHeader>
        {loading ? (
          <Spinner variant="secondary" animation="border" />
        ) : (
          <Price price={price} currencyCode={selectedCurrency!.code} />
        )}
      </PricingHeader>
      <PaymentTypeLabel licence={licence} />
    </>
  );
};

export default SingleUserPricing;
